import { Component, EventEmitter, inject, input, Output } from '@angular/core';
import { ArubaTrustedPlatformName } from '../../../../../common/constants/constants';
import { FormArray, FormGroup } from '@angular/forms';
import { FormGroupContextBase } from '../../voucher-atp/models/FormModels';
import { VoucherFull } from '../../../models/voucherFull';
import { LowerCasePipe } from '@angular/common';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { VoucherAtpModule } from '../../voucher-atp/voucher-atp.module';
import { MatButton, MatIconButton } from '@angular/material/button';
import { UserPermissionDirective } from '../../../shared/directives/user-permission.directive';
import { MatIcon } from '@angular/material/icon';
import { AtpService } from '../../../services/atp.service';
import { LoaderService } from '../../../core/loader.service';
import { VoucherAtpHandlerService } from '../../voucher-atp/service/voucher-atp-handler.service';
import { ToastService } from '../../../services/toast.service';
import { SharedModule } from '../../../shared/shared.module';
import { BitfFile } from '../../../../../common/libs/bitforce/models';
import { AtpModifyRequest } from '../../../models/request/AtpModifyRequest';

@Component({
  selector: 'app-voucher-edit-atp',
  imports: [
    LowerCasePipe,
    MatCard,
    MatCardContent,
    MatCardTitle,
    TranslateModule,
    VoucherAtpModule,
    MatButton,
    UserPermissionDirective,
    MatIcon,
    MatIconButton,
    SharedModule
  ],
  templateUrl: './voucher-edit-atp.component.html',
  styleUrl: './voucher-edit-atp.component.scss',
  standalone: true
})
export class VoucherEditAtpComponent {
  private atpService = inject(AtpService);
  private voucherAtpHandlerService = inject(VoucherAtpHandlerService);
  private toastService = inject(ToastService);
  private translateService = inject(TranslateService);
  private loaderService = inject(LoaderService);

  @Output() updated = new EventEmitter<boolean>();

  voucher = input.required<VoucherFull>();

  arubaTrustedPlatformName = ArubaTrustedPlatformName.toLowerCase();
  formArrayAtp?: FormArray<FormGroup<FormGroupContextBase>>;

  canModify = false;

  saveAtp() {
    if (!this.voucher().client_configuration_id) {
      console.error('Invalid client_configuration_id: ', this.voucher().client_configuration_id);
      return;
    }

    this.loaderService.show();

    const atpModifyRequest: AtpModifyRequest = this.voucherAtpHandlerService.getAtpModifyRequest(this.formArrayAtp);
    atpModifyRequest.client_configuration_id = this.voucher().client_configuration_id;

    this.atpService.modifyAtpConfiguration(atpModifyRequest).subscribe({
      next: () => {
        this.loaderService.hide();
        this.toastService.success({
          message: this.translateService.instant('TOASTR.SAVE_SUCCESS')
        });
        this.canModify = false;
      },
      error: () => this.loaderService.hide()
    });
  }

  async onStartUploadArssConfig(file: BitfFile) {
    this.loaderService.show();
    this.atpService.uploadArssConfiguration(this.voucher().code, file.fileObject).subscribe({
      complete: () => {
        this.loaderService.hide();
        this.toastService.success({
          message: this.translateService.instant('TOASTR.SAVE_SUCCESS')
        });
        this.canModify = false;
        this.updated.emit(true);
        file.resetUploadState();
      },
      error: () => {
        this.loaderService.hide();
        this.toastService.error({
          message: 'Errore durante il caricamento'
        });
        this.updated.emit(false);
        file.resetUploadState();
      }
    });
  }
}
